import { timelineItemClasses } from "@mui/lab/TimelineItem";
import { darkCerulean } from "../../../../styles/colors";

const labStyle = {
  timeLine: {
    [`& .${timelineItemClasses.root}:before`]: {
      flex: 0,
      padding: 0
    }
  },

  loading: {
    color: darkCerulean
  }
};

export default labStyle;
